var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rush-order-auth-apply"},[(_vm.tab === _vm.TABS[0])?_c('ApplyProcess',{on:{"valid":_vm.handleValid}}):(_vm.tab === _vm.TABS[1])?_c('ValidResult',{on:{"valid":_vm.handleValid}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }